// @flow

import { mapGetters, mapState } from 'vuex'

import type { AttributeNameValue, ProductItem } from '@chatchamp/chatchamp-types'

import { logger } from '../../common'

import { postMessageToParent } from '../utils/iframe'

import {
  type IframePayload,
  MESSAGE_TYPE_ADD_TO_CART,
  MESSAGE_TYPE_CHAT_ICON_CLICKED,
  MESSAGE_TYPE_CLOSED,
  MESSAGE_TYPE_CLOSING,
  MESSAGE_TYPE_IMAGE,
  MESSAGE_TYPE_LOADED,
  MESSAGE_TYPE_OPENING,
  MESSAGE_TYPE_PRODUCT_BUTTON,
  MESSAGE_TYPE_RESTART,
  MESSAGE_TYPE_WELCOME_MESSAGE_CLICKED,
  MESSAGE_TYPE_WELCOME_MESSAGE_CLOSED,
  MESSAGE_TYPE_WELCOME_MESSAGE_SHOWN,
  MESSAGE_TYPE_USER_ATTRIBUTE_SET
} from '../../common/iframeMessageTypes'

import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../main/eventTracking'

import iframeSizeMixin from './iframeSizeMixin'

export default {
  mixins: [iframeSizeMixin],
  computed: {
    // $FlowFixMe
    ...mapGetters(['primaryColor', 'isShowingWelcomeMessage']),
    // $FlowFixMe
    ...mapState(['welcomeMessage', 'subscriberId', 'customerId', 'bubble'])
  },
  methods: {
    postMessage (payload: IframePayload) {
      logger.info(`Firing ${payload.event} event...`)
      payload.size = this.getIframeSize()
      payload.subscriberId = this.subscriberId
      payload.customerId = this.customerId
      payload.welcomeMessage = this.welcomeMessage.welcomeMessage
      postMessageToParent(payload)
    },
    notifyWelcomeMessageShown () {
      this.postMessage({ event: MESSAGE_TYPE_WELCOME_MESSAGE_SHOWN })
    },
    notifyLoaded () {
      this.postMessage({ event: MESSAGE_TYPE_LOADED })
      dispatchChatchampEvent(CHATBOT_EVENTS.Loaded, {})
    },
    notifyRestart () {
      this.postMessage({ event: MESSAGE_TYPE_RESTART })
    },
    notifyImage (url: string) {
      this.postMessage({
        event: MESSAGE_TYPE_IMAGE,
        url
      })
    },
    notifyWelcomeMessageClicked () {
      this.postMessage({ event: MESSAGE_TYPE_WELCOME_MESSAGE_CLICKED })
    },
    notifyWelcomeMessageClosed () {
      this.postMessage({ event: MESSAGE_TYPE_WELCOME_MESSAGE_CLOSED })
      dispatchChatchampEvent(CHATBOT_EVENTS.WelcomeMessageClosed, {})
    },
    notifyClicked () {
      this.postMessage({ event: MESSAGE_TYPE_CHAT_ICON_CLICKED })
    },
    notifyClosing () {
      this.postMessage({ event: MESSAGE_TYPE_CLOSING })
    },
    notifyClosed () {
      this.postMessage({ event: MESSAGE_TYPE_CLOSED })
    },
    notifyOpening () {
      this.postMessage({ event: MESSAGE_TYPE_OPENING })
    },
    notifyProductClicked (productId: string, chatbotId: number) {
      this.postMessage({
        event: MESSAGE_TYPE_PRODUCT_BUTTON,
        productId: productId,
        ...(chatbotId && { chatbotId: chatbotId })
      })
    },
    notifyProductsAddedToCart (products: Array<ProductItem>, productIds: string[], chatbotId: number) {
      this.postMessage({
        event: MESSAGE_TYPE_ADD_TO_CART,
        products,
        productIds: productIds.join(','),
        ...(chatbotId && { chatbotId: chatbotId })
      })
    },
    notifyUserAttributeSet (attribute: AttributeNameValue) {
      this.postMessage({
        event: MESSAGE_TYPE_USER_ATTRIBUTE_SET,
        attribute
      })
    }
  }
}
